<template>
    <div>
        <div v-for="(item,i) in dataList" :key="i" class="flex justify-between cursor padding-tb-sm border-b"
            @click="onDetail(item)">
            <img :src='item.filePath' style="width:208px" />
            <div style="width:790px;height:116px" class="margin-left-sm">
                <p class="text-bold text-df ">{{item.title}}</p>
                <p class="text-sm text-grey descr">{{item.shortDescription}}</p>
                <p class="text-sm text-grey"><i class="el-icon-time"></i><span> {{item.updateTime}}</span><i
                        class="el-icon-user margin-left-sm"></i><span> {{item.author}}</span></p>
            </div>
        </div>
        <el-pagination @current-change="getData" :current-page.sync="currentPage" :page-size="10"
            layout="prev, pager, next, jumper" :total="total" class="fr margin-top">
        </el-pagination>
    </div>
</template>
<script>
    import api from "@/utils/api"
    export default {
        data() {
            return {
                dataList: [],
                currentPage: 1,
                apiList: [{
                    key: 'researchReport',//产业研究报告
                    apiName: 'getResearchReportApi',
                    idName:"researchId",
                    type: 1
                }, {
                    key: 'notice',
                    apiName: 'getNoticeApi',
                    idName:'noticeId',
                    type: null
                }, {
                    key: 'news',
                    apiName: 'getNewsApi',
                    idName:'newsId',
                    type: null
                }, {
                    key: 'memberCenter',
                    apiName: 'getVipApi',
                    idName:'vipId',
                    type: null
                }, {
                    key: "industry",
                    apiName: "getPropertyApi",
                    idName:'propertyId',
                    type: null
                }],
                QueryData: {},
                total: 0
            }
        },
        watch: {
            "$route.path": {
                handler() {
                    this.QueryData = this.apiList.filter(e => e.key == this.$route.name)[0]
                    this.getData()
                },
                immediate: true
            }
        },
        methods: {
            async getData() {
                let apiQuery = {
                    type: this.QueryData.type,
                    pageNum: this.currentPage,
                    pageSize: 10
                }
                if (!apiQuery.type) {
                    delete apiQuery.type
                }
                let res = await api[this.QueryData.apiName](apiQuery)
                if (res.code == 200) {
                    this.dataList = res.data.list
                    this.total = res.data.total
                }
            },
            onDetail(val) {
                let name = this.$route.name
                let path=this.$route.path.split('/')[1]
                this.$router.push({
                    path: `/${path}/detail`,
                    query: {
                        name,
                        id:val[this.QueryData.idName]
                    }
                })
            }
        }
    }
</script>
<style scoped>
   .border-b{
    border-bottom: 1px solid #EDEDED;
   }
    .descr {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: wrap;
        line-height: 20px;
    }
</style>